
const BASEURL = "https://backend.relax.scofa.com";
export const FE_BASE_URL = "https://relax.scofa.com";
export const ADMIN_BASE_URL = "https://administratorlive.relax.scofa.com";

export default BASEURL